import { media } from '@payright/web-components';
import styled from 'styled-components';

export const HeadingSubform = styled.h3`
  color: ${(props) => props.theme.colours.blue.base};
  font-size: 1.125rem;

  ${media.min.medium} {
    font-size: 1.5rem;
  }
`;
